<ion-list class="ion-no-margin" lines="none">
  @for (log of logs; track log) {
    <app-log-list-item
      [log]="log"
      [logDivision]="logDivision"
      [shouldTruncate]="shouldTruncate"
      [searchInput]="searchInput"
      [embedded]="embedded"
      [isSelected]="selectedId === log?.id"
      (logSelected)="onLogSelect($event)">
    </app-log-list-item>
  }
</ion-list>
